import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { useOrg } from '../../lib/OrgProvider';
import { SetupFlow } from '../setup/SetupFlow';

/** Only required account setup interrupts the product; trial activation continues directly. */
export const OnboardingSplash = () => {
  const { setupSteps, onboardingState } = useOrg();
  if (setupSteps[0] === 'trial-activated') return <SetupFlow />;
  if (onboardingState.status !== 'create-org' && setupSteps.length === 0) return null;
  return <Dialog open onClose={() => {}} className="relative z-50">
    <DialogBackdrop className="fixed inset-0 bg-background/50 backdrop-blur-md" />
    <div className="fixed inset-0 flex items-center justify-center p-6">
      <DialogPanel className="w-full max-w-md rounded-xl border border-border bg-background p-8">
        <DialogTitle className="sr-only">Set up your account</DialogTitle>
        <SetupFlow />
      </DialogPanel>
    </div>
  </Dialog>;
};
